import CTAButton from "./CTAButton";

export default function BenefitSection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Mengapa Banyak Orang Memilih Produk Ini?";
  const items = content.items || [];

  return (
    <section className="py-20 lg:py-28 bg-gradient-soft">
      <div className="mx-auto max-w-6xl px-5">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Manfaat Utama</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
            {title}
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((b, i) => {
            const isObj = typeof b === "object" && b !== null;
            const icon = isObj ? b.icon : "🌺";
            const itemTitle = isObj ? (b.title || b.text || "") : b;
            const desc = isObj ? b.desc : null;
            return (
              <div
                key={i}
                className="group rounded-3xl bg-white border border-border p-6 shadow-card hover:shadow-luxury hover:-translate-y-1.5 transition-all duration-300"
              >
                <div className="h-14 w-14 rounded-2xl bg-gradient-primary text-white grid place-items-center text-2xl shadow-luxury">
                  {icon}
                </div>
                <h3 className="mt-4 font-bold text-lg">{itemTitle}</h3>
                {desc && <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{desc}</p>}
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
            🔥 Dapatkan Sekarang
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
